import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./NotFound.module.css";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <span className={styles.code}>404</span>
      <h1>{t("notFound.title")}</h1>
      <p>{t("notFound.text")}</p>
      <Link to="/" className={styles.cta}>
        {t("notFound.cta")}
      </Link>
    </div>
  );
}
